exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AddDreamModal-module__content___3ZeNg{display:grid;gap:1.75rem}.AddDreamModal-module__content___3ZeNg button{display:block;margin:0 auto}.AddDreamModal-module__content___3ZeNg .AddDreamModal-module__description___RQ5sD{text-align:center;font-size:14px;margin:0 auto}.AddDreamModal-module__content___3ZeNg h3{text-transform:uppercase;font-size:16px}.AddDreamModal-module__content___3ZeNg h2,.AddDreamModal-module__content___3ZeNg h3{text-align:center;margin-bottom:1rem}.AddDreamModal-module__content___3ZeNg .AddDreamModal-module__dreams___2AA9m{display:grid;grid-template-columns:repeat(auto-fill,minmax(120px,1fr));justify-content:start;gap:1rem}", ""]);

// exports
exports.locals = {
	"content": "AddDreamModal-module__content___3ZeNg",
	"description": "AddDreamModal-module__description___RQ5sD",
	"dreams": "AddDreamModal-module__dreams___2AA9m"
};